import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://cssdemrygohvzruehwhd.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNzc2RlbXJ5Z29odnpydWVod2hkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTQzMTczNDAsImV4cCI6MjA2OTg5MzM0MH0.pOuFfrgwtLH8dRa8G91OfLUxbvSoVNI3qKSCK_fTOto';

// Create Supabase client with proper credentials
export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Auth helper functions
export const auth = {
  signIn: async (phone: string, password: string) => {
    // This would be replaced with actual Supabase auth
    // For now, we'll use the demo credentials
    if (phone === '9103094' && password === 'N@ld1v#s') {
      return {
        user: {
          id: '1',
          phone: phone,
          user_type: 'Admin',
          name: 'Admin User'
        },
        session: {
          access_token: 'demo-token',
          refresh_token: 'demo-refresh-token'
        }
      };
    }
    throw new Error('Invalid credentials');
  },

  signOut: async () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
    return { error: null };
  },

  getCurrentUser: () => {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  }
};

// Database helper functions
export const db = {
  // Inventory items
  getInventoryItems: async (page = 1, limit = 20) => {
    // This would be replaced with actual Supabase query
    return {
      data: [],
      count: 0,
      error: null
    };
  },

  // Departments
  getDepartments: async () => {
    return {
      data: [],
      error: null
    };
  },

  // Vendors
  getVendors: async () => {
    return {
      data: [],
      error: null
    };
  }
}; 